var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogout(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    rx: 17.25,
    fill: "#FBC108",
    fillOpacity: 0.0646
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0527 11C12.5083 11 11.9862 11.2163 11.6012 11.6012C11.2163 11.9862 11 12.5083 11 13.0527V22.6317C11 23.1761 11.2163 23.6982 11.6012 24.0832C11.9862 24.4681 12.5083 24.6844 13.0527 24.6844H17.158C17.7024 24.6844 18.2245 24.4681 18.6094 24.0832C18.9944 23.6982 19.2106 23.1761 19.2106 22.6317V13.0527C19.2106 12.5083 18.9944 11.9862 18.6094 11.6012C18.2245 11.2163 17.7024 11 17.158 11H13.0527ZM20.0953 14.6216C20.2236 14.4933 20.3976 14.4212 20.5791 14.4212C20.7605 14.4212 20.9345 14.4933 21.0628 14.6216L23.7997 17.3584C23.9279 17.4868 24 17.6608 24 17.8422C24 18.0236 23.9279 18.1976 23.7997 18.3259L21.0628 21.0628C20.9338 21.1874 20.7609 21.2564 20.5815 21.2548C20.4021 21.2533 20.2305 21.1813 20.1036 21.0545C19.9768 20.9276 19.9048 20.756 19.9033 20.5766C19.9017 20.3972 19.9707 20.2244 20.0953 20.0953L21.6642 18.5264H15.7895C15.6081 18.5264 15.434 18.4543 15.3057 18.326C15.1774 18.1977 15.1053 18.0236 15.1053 17.8422C15.1053 17.6607 15.1774 17.4867 15.3057 17.3584C15.434 17.2301 15.6081 17.158 15.7895 17.158H21.6642L20.0953 15.5891C19.967 15.4607 19.895 15.2867 19.895 15.1053C19.895 14.9239 19.967 14.7499 20.0953 14.6216Z",
    fill: "#FFC700"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.aa1af5ca3aa228afca0f95122b89506d.svg";
export { ForwardRef as ReactComponent };